import React, { useState, useEffect, useRef, useImperativeHandle } from 'react'
import Maybe from 'components/__new/common/Maybe';
import { ReactComponent as IconAdd } from "assets/images/icons/project-icons/plus-light.svg"
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import SearchableBillPaymentProviders from '../Providers';
import useLoginInfo from 'hooks/useLoginInfo';
import { ReactComponent as IconCheckCircle } from "assets/images/icons/project-icons/check-circle-green-bg.svg"
import { cableTvPurchaseValidation, getCableTvBouquets } from 'store/entities/billPayment/action';
import { default as ReactSelect, components } from "react-select";
import CurrencyFormat from 'utils/currencyFormat';


const MultipleCablePurchase = ({
    togglePurchaseModal,
    isWideViewOpen,
    setIsWideViewOpen,
    previewItems,
    setPreviewItems,
}) => {
    const dispatch = useDispatch();
    const {userInfo} = useLoginInfo();
    const searchableBillPaymentProvidersRef = useRef();
    const searchableCableTvBouquetsRef = useRef();

    const defaultForm = {
        amount: "",
        account: "",    // smartcard number
        service: "",    // multichoice or startimes
        decoderType: {},
        bouquet: {},
        months: 1,

        type: "subscription",
        bouquetCode: "",
        addonCode: "",
        
        name: "",
        isValidated: false,
    }
    
    const [form, setForm] = useState(defaultForm);
    
    // eslint-disable-next-line
    const [beneficiariesShown, setBeneficiariesShown] = useState(false);
    const { cableTvValidationLoading: isValidating, cableTvValidation: validatedData } = useSelector((s) => s.entities.billPayment);    
    const [validatedSmartCard, setValidatedSmartCard] = useState(null);
    
    const onClose = () => {
        togglePurchaseModal();
    }
    
    const resetValues = () => {
        setForm(defaultForm);
        searchableBillPaymentProvidersRef?.current?.clearSearchableBillPaymentProviders();
        searchableCableTvBouquetsRef?.current?.clearSearchableCableTvBouquets();
        setForm(defaultForm);
        setValidatedSmartCard(null);
    }
    
    const addRecipient = (e) => {
        e.preventDefault();
        
        const duplicateItem = previewItems?.find((item) => item?.account === form.account)
        
        if(previewItems?.length === 20) {
            toast.error(`You can only add ${previewItems?.length} recipients`)
        } else {
            if(!form?.decoderType?.value) {
                toast.error("Please select a biller")
            } else if(form.account?.length !== 10) {
                toast.error("Please enter a valid smart card number")
            } else if(duplicateItem) {
                toast.error(`${duplicateItem?.account} has already been added`)
            } else {
                setPreviewItems([
                    ...previewItems,
                    {...form, amount: 0, fee: 0}
                ]);
                setIsWideViewOpen(true);
                resetValues();
            }
        }
    }
    
    useEffect(() => {
        if(form?.account?.length === 10 && form?.decoderType?.value?.length) {
            const params = {
                account: form.account,
                userId: userInfo.employer._id,
                decoderType: form?.decoderType?.value === "startimes" ? "default" : form?.decoderType?.value,
                service: form?.decoderType?.value === "startimes" ? "startimes" : "multichoice",
            }
            dispatch(cableTvPurchaseValidation(params));
        }
        // eslint-disable-next-line
    }, [form?.account, form?.decoderType])
    
    
    useEffect(() => {
        if(validatedData?.status === 'success') {
            setValidatedSmartCard(validatedData?.response);
            setForm({
                ...form,
                name: validatedData?.response?.name,
                address: validatedData?.response?.address
            })
        }
        // eslint-disable-next-line
    }, [validatedData])
    
    
    useEffect(() => {
        setPreviewItems([]);
        searchableBillPaymentProvidersRef?.current?.clearSearchableBillPaymentProviders();
        setValidatedSmartCard(null);
        setForm(defaultForm);
        // eslint-disable-next-line
    }, [])
    
    useEffect(() => {
        let newForm = {...form};
        if (form.decoderType?.value === "startimes"){
            newForm = {...newForm, service: "startimes"};
        }
        else{
            newForm = {...newForm, service: "multichoice"};
        }
        setForm(newForm);
        // eslint-disable-next-line
    }, [form.decoderType])
    
    return (
        <div className='w-full relative'>
            <form onSubmit={addRecipient}>
                <div className="w-full">
                    
                    <div className="relative">
                        <SearchableBillPaymentProviders
                            type="cableTv"
                            label="Biller"
                            tag="products"
                            ref={searchableBillPaymentProvidersRef}
                            onValueChange={(e) => {
                                setForm({...form, decoderType: e, bouquet: {}, bouquetCode: "", amount: "", account: ""});
                                searchableCableTvBouquetsRef?.current?.clearSearchableCableTvBouquets();
                                setValidatedSmartCard(null);
                            }}
                        />
                        
                        {/* <div onClick={() => setBeneficiariesShown(!beneficiariesShown)} className='text-sm cursor-pointer border-b border-ep-primary-600 text-ep-primary-600 absolute -bottom-6'>
                            {beneficiariesShown ? "Close search" : "Or Search Beneficiary List"}
                        </div> */}
                    </div>
                    
                    <div className="mt-6">
                        <SearchableCableTvBouquets
                            label="Select Product"
                            service={form.service}
                            decoderType={form.decoderType}
                            months={form.months || 1}
                            ref={searchableCableTvBouquetsRef}
                            onValueChange={(e) => setForm({...form, bouquet: e, bouquetCode: e.value, amount: e.amount})}
                        />
                    </div>
                    
                    <div className="form-group">
                        <label>Amount</label>
                        <input
                            disabled
                            type="number"
                            id="prl-input"
                            className="form-input"
                            value={form.amount}
                            placeholder="0.00"
                        />
                    </div>
                    
                    <div className='form-group relative'>
                        <label>Smart Card Number</label>
                        <input
                            type="number"
                            id="prl-input"
                            className="form-input"
                            value={form.account}
                            placeholder="Enter Number"
                            onChange={(e) => setForm({...form, account: e.target.value})}
                        />
                        
                        <Maybe condition={validatedSmartCard !== null}>
                            <div className="w-full flex items-center justify-start absolute -bottom-7">
                                <div className="flex items-center text-sm">
                                    <IconCheckCircle width={15} />
                                    <div className='ml-1.5 text-[#153344] capitalize text-xs'>{validatedSmartCard?.name?.toLowerCase()}</div>
                                </div>
                            </div>
                        </Maybe>
                    </div>
                </div>
                
                <div className="pt-3 border-t mt-9">
                    <button disabled={isValidating} type="submit" className="btn btn-transparent-primary w-full disabled:cursor-not-allowed">
                        <IconAdd width={15} />&nbsp;
                        {isValidating ? "Validating..." : "Add Another"}
                    </button>
                </div>
                
                <Maybe condition={isWideViewOpen === false}>
                    <div className="w-full flex items-center justify-end pt-8">
                        <button type="button" onClick={onClose} className="btn btn-transparent-primary mr-3">
                            Cancel
                        </button>
                        
                        <button disabled type="button" className="btn btn-ep-primary">
                            {isValidating ? "Validating..." : "Continue"}
                        </button>
                    </div>
                </Maybe>
            </form>
        
            <Maybe condition={beneficiariesShown}>
                {/* <BeneficiariesList
                    addBatchBeneficiaries={addBatchBeneficiaries}
                /> */}
            </Maybe>
        </div>
    )
}


export const SearchableCableTvBouquets = React.forwardRef((props, ref) => {
    const {userInfo} = useLoginInfo();
    const dispatch = useDispatch();
    const { cableTvBouquetsLoading, cableTvBouquets } = useSelector((s) => s.entities.billPayment);

    const [options, setOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState({});


    const getOptions = () => {
        if (cableTvBouquets?.response !== undefined){
            if (cableTvBouquets?.response !== undefined && cableTvBouquets?.response.length > 0){
                const data = cableTvBouquets?.response.map((bouquet) => {
                    const pricingObject = bouquet?.availablePricingOptions.filter((option) => option.monthsPaidFor === 1);
                    const pricing = pricingObject[0] !== undefined ? pricingObject[0].price : "";
                    return {
                        label: bouquet?.name,
                        value: bouquet?.code,
                        name: bouquet?.name,
                        amount: pricing,
                    }
                })
                setOptions(data);
            }
            else{
                setOptions([]);
            }
        }
        else{
            setOptions([]);
        }
    }

    const updateSelection = (e) => {
        setSelectedOption(e);
        props.onValueChange(e);
    }

    const clearSearchableCableTvBouquets = () => {
        setSelectedOption({});
    }


    useEffect(() => {
        if (props.decoderType?.value !== undefined && props.decoderType?.value !== ""){
            const params = {
                userId: userInfo.employer._id,
                service: props.service,
                decoderType: props.decoderType?.value === "startimes" ? "default" : props.decoderType?.value,
            }
            dispatch(getCableTvBouquets(params));
        }
        else{
            setOptions([]);
        }
        // eslint-disable-next-line
    }, [props.service, props.decoderType]);


    useEffect(() => {
        if (cableTvBouquets?.status === "success"){
            getOptions();
        }
        else{
            setOptions([]);
        }
        // eslint-disable-next-line
    }, [cableTvBouquets]);


    useImperativeHandle(ref, () => ({
        clearSearchableCableTvBouquets
    }));

    return (
        <div className="form-group">
            <label>{props.label}</label>

            <Maybe condition={cableTvBouquetsLoading === true}>
                <input type="text" value={"Loading bouquets..."} readOnly={true} className="form-input" />
            </Maybe>

            <Maybe condition={cableTvBouquetsLoading === false}>
                <ReactSelect
                    options={options}
                    placeholder="Select product first"
                    noOptionsMessage={() => "No bouquets yet"}
                    styles={ReactSelectStyles}
                    isMulti={false}
                    closeMenuOnSelect={true}
                    hideSelectedOptions={false}
                    components={{Option}}
                    onChange={(e) => updateSelection(e)}
                    value={selectedOption}
                />
            </Maybe>
        </div>
    )
})


const Option = (props) => {
    return (
        <div className="p-0">
            <components.Option {...props}>
                <div className="-mx-2 -my-1.5 p-4 text-sm flex rounded-sm hover:bg-[#f3f5f6]">
                    <div className="flex-grow text-left text-[#1f2937]">
                        {props.label} - {CurrencyFormat(props.data.amount) ?? "-"}
                    </div>
                </div>
            </components.Option>
        </div>
    );
};


const ReactSelectStyles = {
    option: (provided, state) => ({
        ...provided,
        color: "#333",
        background: "#fff",
        cursor: "pointer",
        "&:hover": {
            background: "#eee",
        }
    }),
    
    control: (provided, state) => ({
        ...provided,
        border: "1px solid #ddd",
        boxShadow: "none",
        outline: "none",
        "&:hover": {
            border: "1px solid #eee",
            outline: "none",
        },
    }),
};



export default MultipleCablePurchase